const onOpenAppStore = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('android') !== -1) {
    window.open(`https://play.google.com/store/apps/details?id=com.buyofuelmobile`);
  } else if (userAgent.indexOf('iphone') !== -1) {
    window.open(`https://apps.apple.com/in/app/buyofuel/id1631586762`);
  } else {
    window.open(`https://app.buyofuel.com/`);
  }
};

export { onOpenAppStore };
